  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="primary"
               class="topbar telative">
    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header">
      <a class="navbar-brand"
         href="index.html">
        <!-- Logo icon -->
        <b>
          <!-- Dark Logo icon -->
          <img src="assets/images/odq-logo-Icon-small.png"
               alt="homepage"
               class="light-logo">
        </b>
        <!--End Logo icon -->
        <!-- Logo text -->
        <span class="d-none d-sm-flex">
          <!-- dark Logo text -->
          <!-- Light Logo text -->
          <img src="assets/images/odq-logo-text-small.png"
               class="light-logo"
               alt="homepage">
        </span>
      </a>
    </div>
    </mat-toolbar>